import React from "react";
import { useNavigate, NavLink } from "react-router-dom";
import { SidebarData, CustomerSidebarData } from "./SidebarData";
import "./Sidebar.css";

const Sidebar = ({ isCustomer }) => {
  const navigate = useNavigate();
  const userRole = localStorage.getItem("adminRole");

  let filteredSidebarData;
  if (isCustomer) {
    filteredSidebarData = CustomerSidebarData;
  } else {
    filteredSidebarData = SidebarData.filter((item) =>
      item.roles.includes(userRole)
    );
  }
  return (
    <div className="sidebar">
      <h3
        onClick={() =>
          navigate(isCustomer ? "/customer/dashboard" : "/admin/dashboard")
        }
      >
        Tennis String Management
      </h3>
      <ul>
        {filteredSidebarData.map((item, index) => (
          <li key={index}>
            <NavLink
              to={item.path}
              className="sidebar-link"
              activeClassName="active-link"
            >
              {item.title}
            </NavLink>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Sidebar;